export default {
    auth: {
        login: {
            buttons: {
                enter: 'Enter',
                otherStudent: 'Enter as Another Student',
                otherClassroom: 'Enter a Different Classroom',
                pwa: 'Create Shortcut',
            },
            pwa: {
                title: 'Want to create a shortcut on your home screen like an app?',
                description: 'You can enter directly without a classroom code from now on!',
                install: {
                    ios: 'Tap the "Share" button at the bottom of your Safari browser and select "Add to Home Screen".',
                    android: 'Tap the browser menu (⋮) and select "Install App".',
                    default: 'Select "Add to Home Screen" or "Install App" from the browser menu.',
                },
                buttons: {
                    next: 'Maybe Next Time',
                    create: 'Create Shortcut',
                },
            },
            pinSet: 'Your PIN has been set! Please enter the Session.',
            stepClassroom: {
                title: 'Enter as Student',
                description: 'Please enter the classroom code your Teacher shared with you!',
            },
            stepPin: {
                studentInfo: 'No.{number} {name}',
                input: 'Enter your PIN to join the Session.',
                set: 'Set your PIN to join the Session.',
                retry: 'Please enter your PIN once more.',
                tip: "You'll need your PIN to enter the Session, so make sure to remember it!",
                error: {
                    confirm: "Your PIN doesn't match! Please check and try again.",
                    unknown: 'An unknown error has occurred.',
                    pin: 'Unable to verify your PIN.',
                    set: 'Unable to set your PIN.',
                },
            },
            stepStudent: {
                title: 'Please enter your attendance number and name!',
                placeholder: {
                    number: 'Enter attendance number (numbers only)',
                    name: 'Enter your name (Korean only)',
                },
                error: {
                    nameKorean: 'Only Korean characters are allowed.',
                    number: 'Only numbers are allowed.',
                    unknown: 'An unknown error has occurred.',
                },
            },
        },
    },
};
